import { BrowserRouter, Route, Routes, Outlet } from 'react-router-dom'
import "./index.css";
import AccountVerification from './forms/AccountVerification'
import YourInfo from './forms/pages/YourInfo'
import ProfilePhoto from './forms/pages/ProfilePhoto'
import RenderForm from './forms/pages/RenderForm'
import ProtectedRoute from './components/ProtectedRoute'
import TokenAuthLoader from './components/TokenAuthLoader'
import InvalidAuthorization from './components/InvalidAuthorization'
import DocumentsDashboard from './forms/DocumentsDashboard'

export function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Token authentication route - shows loader and handles authentication */}
        <Route path="/" element={<TokenAuthLoader />} />

        {/* Protected routes - require authentication */}
        <Route element={<ProtectedRoute><Outlet /></ProtectedRoute>}>
          <Route path="/forms" element={<AccountVerification />} />
          <Route path="/your-info" element={<YourInfo />} />
          <Route path="/profile-photo" element={<ProfilePhoto />} />
          <Route path="/documents" element={<DocumentsDashboard />} />
          <Route path="/form/:formHeader" element={<RenderForm />} />
        </Route>

        <Route path="/invalid-authorization" element={<InvalidAuthorization />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
